// noinspection SpellCheckingInspection


import {LanguageLocale} from "@/api/model/languageLocale";

type Keyword = {
    [T in LanguageLocale]: string;
};

type Keywords = {
    [T in string]: Keyword;
};

const generalKeywords = {
    welcome: {
        de: "Willkommen zurück!",
        it: "Bentornato!",
    },
    settings: {
        de: "Einstellungen",
        it: "Impostazioni",
    },
    language: {
        de: "Sprache",
        it: "Lingua",
    },
    noConnection: {
        de: "Bitte überprüfe deine Internetverbindung!",
        it: "Controlla la tua connessione a Internet!",
    },
    skip: {
        de: "Überspringen",
        it: "Salta",
    },
    continue: {
        de: "Weiter",
        it: "Continua",
    },
    choose_picker: {
        de: "– Bitte wählen –",
        it: "– Seleziona –",
    },
    error_occurred: {
        de: "Ups … da ist ein Fehler aufgetreten!",
        it: "Ops … si è verificato un errore!",
    },
    impressum: {
        de: "Impressum",
        it: "Impressum",
    },
    privacy: {
        de: "Datenschutzerklärung",
        it: "Informativa sulla privacy",
    },
    register: {
        de: "Registrieren",
        it: "Registrati",
    },
    login: {
        de: "Anmelden",
        it: "Accedi",
    },
    logout: {
        de: "Abmelden",
        it: "Esci",
    },
    username: {
        de: "Benutzername",
        it: "Nome utente",
    },
    email: {
        de: "E-Mail",
        it: "E-mail",
    },
    registerNow: {
        de: "Konto erstellen",
        it: "Crea un account",
    },
    password: {
        de: "Passwort",
        it: "Password",
    },
    passwordRepeat: {
        de: "Passwort wiederholen",
        it: "Ripeti la password",
    },
    pwNotSame: {
        de: "Die Passwörter stimmen nicht überein",
        it: "Le password non corrispondono",
    },
    mailInvalid: {
        de: "E-Mail-Adresse ungültig",
        it: "Indirizzo e-mail non valido",
    },
    mailGiven: {
        de: "E-Mail-Adresse bereits vergeben",
        it: "Indirizzo e-mail già in uso",
    },
    usernameGiven: {
        de: "Benutzername bereits vergeben",
        it: "Nome utente già in uso",
    },
    save: {
        de: "Speichern",
        it: "Salva",
    },
    cancel: {
        de: "Abbrechen",
        it: "Annulla",
    },
    somethingWentWrong: {
        de: "Etwas ist schiefgelaufen, bitte versuche es erneut",
        it: "Qualcosa è andato storto, riprova",
    },
    rateLimited: {
        de: "Zu viele fehlgeschlagene Versuche, bitte versuche es später erneut",
        it: "Troppi tentativi falliti, riprova più tardi",
    },
    credentialsWrong: {
        de: "Benutzername oder Passwort falsch",
        it: "Nome utente o password errati",
    },
    enterCredentials: {
        de: "Bitte gib deine Zugangsdaten ein",
        it: "Inserisci le tue credenziali",
    },
    dryingUnits: {
        de: "Anlagen",
        it: "Impianti",
    },
    dryingUnit: {
        de: "Anlage",
        it: "Impianto",
    },
    chooseDryingUnit: {
        de: "Anlage wählen",
        it: "Seleziona l'impianto",
    },
    runningMode: {
        de: "Betriebsart",
        it: "Modalità di funzionamento",
    },
    feedState: {
        de: "Futterzustand",
        it: "Stato del foraggio",
    },
    humidity: {
        de: "Feuchte",
        it: "Umidità",
    },
    temperature: {
        de: "Temperatur",
        it: "Temperatura",
    },
    switchoverHumidity: {
        de: "Umschaltfeuchte",
        it: "Umidità di commutazione",
    },
    runningTime: {
        de: "Laufzeit",
        it: "Tempo di funzionamento",
    },
    pauseTime: {
        de: "Pausenzeit",
        it: "Tempo di pausa",
    },
    pause: {
        de: "Pause",
        it: "In pausa",
    },
    running: {
        de: "Läuft",
        it: "In funzione",
    },
    turnsOffAt: {
        de: "schaltet automatisch ab, sobald [border] erreicht ist.",
        it: "si spegne automaticamente al raggiungimento di [border].",
    },
    operationModeManual: {
        de: "Handbetrieb",
        it: "Funzionamento manuale",
    },
    operationModeOff: {
        de: "Aus",
        it: "Spento",
    },
    operationModePrioritySwitch: {
        de: "Prio. Schalter",
        it: "Interruttore prioritario",
    },
    operationModeAutomatic: {
        de: "Automatik",
        it: "Automatico",
    },
    operationModeAutomaticInterval: {
        de: "Intervallbetrieb",
        it: "Funzionamento a intervalli",
    },
    operationModeAutomaticConstant: {
        de: "Dauerbetrieb",
        it: "Funzionamento continuo",
    },
    operationModeTimer: {
        de: "Zeituhr",
        it: "Timer",
    },
    operationModeTimerSimple: {
        de: "Einfache Zeituhr",
        it: "Timer semplice",
    },
    operationModeTimerExtended: {
        de: "Erweiterte Zeituhr",
        it: "Timer avanzato",
    },
    operationModeManualDesc: {
        de: "Die Anlage läuft im Dauerbetrieb bis zur manuellen Abschaltung.",
        it: "L'impianto funziona in modo continuo fino allo spegnimento manuale.",
    },
    operationModeOffDesc: {
        de: "Die Anlage ist deaktiviert.",
        it: "L'impianto è disattivato.",
    },
    operationModePrioritySwitchDesc: {
        de: "Bitte verwende den Schalter oder ändere die Betriebsart.",
        it: "Usa l'interruttore oppure modifica la modalità di funzionamento.",
    },
    feedStatePostDrying: {
        de: "Nachtrocknen",
        it: "Post-essiccazione",
    },
    feedStateDry: {
        de: "Trocken",
        it: "Secco",
    },
    feedStateNearlyDry: {
        de: "Fast trocken",
        it: "Quasi secco",
    },
    feedStateMediumMoist: {
        de: "Mittel feucht",
        it: "Mediamente umido",
    },
    feedStateMoist: {
        de: "Feucht",
        it: "Umido",
    },
    feedStateVeryMoist: {
        de: "Sehr feucht",
        it: "Molto umido",
    },
    anyFeedStateDesc: {
        de: `[humidity] % r.F. – [pause] h Pausenzeit`,
        it: `[humidity] % U.R. – [pause] h di pausa`
    },
    window: {
        de: "Fenster",
        it: "Finestra oraria",
    },
    totalRunningTime: {
        de: "Gesamtlaufzeit / Tag",
        it: "Tempo di funzionamento totale / giorno",
    },
    minutesShort: {
        de: "Min.",
        it: "min",
    },
    secondsShort: {
        de: "Sek.",
        it: "sec",
    },
    hoursShort: {
        de: "Std.",
        it: "h",
    },
    daysShort: {
        de: "Tg.",
        it: "Gi.",
    },
    days: {
        de: "Tage",
        it: "Giorni",
    },
    minutes: {
        de: "Minuten",
        it: "minuti",
    },
    seconds: {
        de: "Sekunden",
        it: "secondi",
    },
    hours: {
        de: "Stunden",
        it: "ore",
    },
    roof: {
        de: "Dachwerte",
        it: "Valori al tetto",
    },
    roofTemperature: {
        de: "Dach-Temperatur",
        it: "Temperatura al tetto",
    },
    roofHumidity: {
        de: "Dach-Feuchte",
        it: "Umidità al tetto",
    },
    airFlowValues: {
        de: "Einblaswerte",
        it: "Valori dell'aria di mandata",
    },
    airFlowTemperature: {
        de: "Einblas-Temperatur",
        it: "Temperatura dell'aria di mandata",
    },
    airFlowHumidity: {
        de: "Einblas-Feuchte",
        it: "Umidità dell'aria di mandata",
    },
    supplyAirFlow: {
        de: "Einblasluftmenge",
        it: "Portata dell'aria di mandata",
    },
    setSupplyAirFlowRate: {
        de: "Soll-Einblasluftmenge",
        it: "Portata nominale dell'aria di mandata",
    },
    setSupplyAirFlowRates: {
        de: "Soll-Einblasluftmengen",
        it: "Portate nominali dell'aria di mandata",
    },
    actualSupplyAirFlowRate: {
        de: "Ist-Einblasluftmenge",
        it: "Portata effettiva dell'aria di mandata",
    },
    fanPower: {
        de: "Ventilatorleistung",
        it: "Potenza del ventilatore",
    },
    heatingCoil: {
        de: "Heizbatterie",
        it: "Batteria di riscaldamento",
    },
    heatCoilSetTemperature: {
        de: "Heizsollwert",
        it: "Setpoint di riscaldamento",
    },
    heatCoilStopTemperature: {
        de: "Heizregister aus",
        it: "Spegnimento del riscaldamento",
    },
    heatCoilValveOpening: {
        de: "Ventilöffnung",
        it: "Apertura della valvola",
    },
    systemInformation: {
        de: "System-Informationen",
        it: "Informazioni di sistema",
    },
    overview: {
        de: "Übersicht",
        it: "Panoramica",
    },
    control: {
        de: "Steuerung",
        it: "Controllo",
    },
    stats: {
        de: "Statistik",
        it: "Statistiche",
    },
    noDryingUnitData: {
        de: "Keine Daten gefunden",
        it: "Nessun dato trovato",
    },
    moreSettings: {
        de: "Weitere Einstellungen",
        it: "Altre impostazioni",
    },
    chooseFeedState: {
        de: "Futterzustand wählen",
        it: "Seleziona lo stato del foraggio",
    },
    editSupplyAirFlow: {
        de: "Einblasluftmenge bearbeiten",
        it: "Modifica la portata dell'aria di mandata",
    },
    infos: {
        de: "Informationen",
        it: "Informazioni",
    },
    editHeatingCoil: {
        de: "Heizbatterie bearbeiten",
        it: "Modifica la batteria di riscaldamento",
    },
    saveSuccess: {
        de: "Erfolgreich gespeichert",
        it: "Salvataggio riuscito",
    },
    saveFailed: {
        de: "Speichern fehlgeschlagen",
        it: "Salvataggio non riuscito",
    },
    operationModeSet: {
        de: "Betriebsart auf „[mode]“ geändert.",
        it: "Modalità di funzionamento impostata su «[mode]».",
    },
    valuesSaved: {
        de: "Die Werte wurden erfolgreich gespeichert",
        it: "I valori sono stati salvati con successo",
    },
    valuesNotSaved: {
        de: "Die Werte konnten nicht gespeichert werden",
        it: "Non è stato possibile salvare i valori",
    },
    feedStateSaved: {
        de: "Futterzustand auf „[state]“ geändert.",
        it: "Stato del foraggio impostato su «[state]».",
    },
    feedStateNotSaved: {
        de: "Der Futterzustand konnte nicht geändert werden.",
        it: "Non è stato possibile modificare lo stato del foraggio.",
    },
    noTimerMode: {
        de: "Keine Zeituhr",
        it: "Nessun timer",
    },
    noTimerModeDesc: {
        de: "Es wurde noch keine Zeituhr ausgewählt …",
        it: "Non è ancora stato selezionato alcun timer …",
    },
    timerEdit: {
        de: "Zeituhr bearbeiten",
        it: "Modifica il timer",
    },
    timerSaved: {
        de: "Die neuen Zeituhr-Einstellungen wurden übernommen",
        it: "Le nuove impostazioni del timer sono state applicate",
    },
    createTimerExtendedDesc: {
        de: "Lege unten ein oder mehrere Zeitfenster fest, in denen die Anlage laufen soll. Der Zyklus wiederholt sich täglich automatisch.",
        it: "Definisci qui sotto una o più fasce orarie in cui l'impianto deve funzionare. Il ciclo si ripete automaticamente ogni giorno.",
    },
    startTime: {
        de: "Startzeit",
        it: "Ora di inizio",
    },
    endTime: {
        de: "Endzeit",
        it: "Ora di fine",
    },
    statsComingSoon: {
        de: "Die Statistiken sind unterwegs!",
        it: "Le statistiche sono in arrivo!",
    },
    functions: {
        de: "Funktionen",
        it: "Funzioni",
    },
    users: {
        de: "Benutzer",
        it: "Utenti",
    },
    name: {
        de: "Name",
        it: "Nome",
    },
    action: {
        de: "Aktion",
        it: "Azione",
    },
    edit: {
        de: "Bearbeiten",
        it: "Modifica",
    },
    designation: {
        de: "Bezeichnung",
        it: "Denominazione",
    },
    serialNumber: {
        de: "Seriennummer",
        it: "Numero di serie",
    },
    connectedUser: {
        de: "Verbundene Benutzer",
        it: "Utenti collegati",
    },
    status: {
        de: "Status",
        it: "Stato",
    },
    createDryingUnit: {
        de: "Anlage erstellen",
        it: "Crea un impianto",
    },
    createUser: {
        de: "Benutzer erstellen",
        it: "Crea un utente",
    },
    createdSuccessfully: {
        de: "[type] erfolgreich erstellt!",
        it: "[type]: creazione riuscita!",
    },
    editedSuccessfully: {
        de: "Änderungen an [type] erfolgreich gespeichert!",
        it: "[type]: modifiche salvate con successo!",
    },
    deactivate: {
        de: "Deaktivieren",
        it: "Disattiva",
    },
    commentOnSupplyAirFlow: {
        de: "Angaben zur Einblasluftmenge",
        it: "Indicazioni sulla portata dell'aria di mandata",
    },
    firstName: {
        de: "Vorname",
        it: "Nome",
    },
    lastName: {
        de: "Nachname",
        it: "Cognome",
    },
    german: {
        de: "Deutsch",
        it: "Tedesco",
    },
    italian: {
        de: "Italienisch",
        it: "Italiano",
    },
    noUsers: {
        de: "Die Benutzerliste konnte nicht geladen werden!",
        it: "Non è stato possibile caricare l'elenco degli utenti!",
    },
    backoffice: {
        de: "Backoffice",
        it: "Backoffice",
    },
    delete: {
        de: "Löschen",
        it: "Elimina",
    },
    noDryingUnits: {
        de: "Keine Anlagen",
        it: "Nessun impianto",
    },
    pwaInstallApp: {
        de: "Installiere Mein Heu für schnelleren Zugriff.",
        it: "Installa Mein Heu per un accesso più rapido.",
    },
    pwaTab: {
        de: "Tippe auf",
        it: "Tocca",
    },
    pwaShare: {
        de: "Teilen",
        it: "Condividi",
    },
    pwaShowMore: {
        de: "Mehr anzeigen",
        it: "Mostra altro",
    },
    pwaAddToHomescreen: {
        de: "Zum Home-Bildschirm",
        it: "Aggiungi alla schermata Home",
    },
    pwaInstallHeuPilot: {
        de: "Mein Heu installieren",
        it: "Installa Mein Heu",
    },
    pwaInstallNow: {
        de: "Installieren",
        it: "Installa",
    },
    pwaNotNow: {
        de: "Nicht jetzt",
        it: "Non ora",
    },
    connectedUnits: {
        de: "Verbundene Anlagen",
        it: "Impianti collegati",
    },
    remove: {
        de: "Entfernen",
        it: "Rimuovi",
    },
    assignUnit: {
        de: "Anlage hinzufügen",
        it: "Aggiungi un impianto",
    },
    assignedSuccessfully: {
        de: "Erfolgreich hinzugefügt",
        it: "Aggiunta riuscita",
    },
    assignedSuccessfullyCont: {
        de: "Die Anlage wurde diesem Benutzer erfolgreich zugewiesen",
        it: "L'impianto è stato assegnato con successo a questo utente",
    },
    assignFailed: {
        de: "Hinzufügen fehlgeschlagen",
        it: "Aggiunta non riuscita",
    },
    assignFailedCont: {
        de: "Die Anlage konnte diesem Benutzer nicht zugewiesen werden!",
        it: "Non è stato possibile assegnare l'impianto a questo utente!",
    },
    unlinkSuccessfully: {
        de: "Erfolgreich entfernt",
        it: "Rimozione riuscita",
    },
    unlinkSuccessfullyCont: {
        de: "Die Anlage wurde erfolgreich von diesem Benutzer entfernt",
        it: "L'impianto è stato rimosso con successo da questo utente",
    },
    unlinkFailed: {
        de: "Entfernen fehlgeschlagen",
        it: "Rimozione non riuscita",
    },
    unlinkFailedCont: {
        de: "Die Anlage konnte von diesem Benutzer nicht entfernt werden!",
        it: "Non è stato possibile rimuovere l'impianto da questo utente!",
    },
    connectedUsers: {
        de: "Verbundene Benutzer",
        it: "Utenti collegati",
    },
    assignUser: {
        de: "Benutzer hinzufügen",
        it: "Aggiungi un utente",
    },
    flowCanBeBetween: {
        de: "Die Soll-Einblasluftmenge kann von [min] bis [max] eingestellt werden!",
        it: "La portata nominale dell'aria di mandata può essere impostata da [min] a [max]!",
    },
    deleteUser: {
        de: "Benutzer löschen",
        it: "Elimina l'utente",
    },
    sureDeleteUser: {
        de: "Möchtest du diesen Benutzer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!",
        it: "Vuoi davvero eliminare questo utente? Questa azione non può essere annullata!",
    },
    deleteUnit: {
        de: "Anlage löschen",
        it: "Elimina l'impianto",
    },
    sureDeleteUnit: {
        de: "Möchtest du diese Anlage wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!",
        it: "Vuoi davvero eliminare questo impianto? Questa azione non può essere annullata!",
    },
    yes: {
        de: "Ja",
        it: "Sì",
    },
    no: {
        de: "Nein",
        it: "No",
    },
    actualState: {
        de: "Aktueller Status",
        it: "Stato attuale",
    },
    unitOffline: {
        de: "Anlage offline",
        it: "Impianto offline",
    },
    lastSyncAt: {
        de: "Zuletzt aktualisiert am",
        it: "Ultimo aggiornamento:",
    },
    lastSyncBefore: {
        de: "Zuletzt aktualisiert vor",
        it: "Aggiornato da",
    },
    retry: {
        de: "Erneut versuchen",
        it: "Riprova",
    },
    refresh: {
        de: "Aktualisieren",
        it: "Aggiorna",
    },
    intervalModeExpl: {
        de: "Intervallbetrieb läuft, da die aktuelle Dach-Feuchte ([actual] % r.F.) über der Umschaltfeuchte ([switchover] % r.F.) liegt",
        it: "Il funzionamento a intervalli è attivo perché l'umidità al tetto ([actual] % U.R.) è superiore all'umidità di commutazione ([switchover] % U.R.)",
    },
    passwordPolicyLength: {
        de: "Zwischen [min] und [max] Zeichen",
        it: "Tra [min] e [max] caratteri",
    },
    passwordPolicyAnyLetter: {
        de: "Enthält Buchstaben",
        it: "Contiene lettere",
    },
    passwordPolicyLower: {
        de: "Enthält Kleinbuchstaben",
        it: "Contiene lettere minuscole",
    },
    passwordPolicyUpper: {
        de: "Enthält Großbuchstaben",
        it: "Contiene lettere maiuscole",
    },
    passwordPolicyDigit: {
        de: "Enthält eine Ziffer",
        it: "Contiene una cifra",
    },
    passwordPolicySymbol: {
        de: "Enthält ein Sonderzeichen (?!$%-_#…)",
        it: "Contiene un carattere speciale (?!$%-_#…)",
    },
    missing: {
        de: "Noch [hours] h [minutes] Min.",
        it: "Ancora [hours] h [minutes] min",
    },
    missingMinutes: {
        de: "Noch [minutes] Min.",
        it: "Ancora [minutes] min",
    },
    description: {
        de: "Beschreibung",
        it: "Descrizione",
    },
    airFlow: {
        de: "Luftmenge",
        it: "Portata d'aria",
    },
    deleteBox: {
        de: "Box löschen",
        it: "Elimina il box",
    },
    sureDeleteBox: {
        de: "Möchtest du diese Box wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden!",
        it: "Vuoi davvero eliminare questo box? Questa azione non può essere annullata!",
    },
    createBox: {
        de: "Box hinzufügen",
        it: "Aggiungi un box",
    },
    box: {
        de: "Box",
        it: "Box",
    },
    search: {
        de: "Suchen",
        it: "Cerca",
    },
    roof_temp: {
        de: "Dach-Temperatur",
        it: "Temperatura al tetto",
    },
    supply_air_flow_temp: {
        de: "Einblas-Temperatur",
        it: "Temperatura dell'aria di mandata",
    },
    supply_air_flow_humidity: {
        de: "Einblas-Feuchte",
        it: "Umidità dell'aria di mandata",
    },
    roof_humidity: {
        de: "Dach-Feuchte",
        it: "Umidità al tetto",
    },
    plant_running: {
        de: "Laufzeit",
        it: "Tempo di funzionamento",
    },
    supply_air_flow: {
        de: "Einblasluftmenge",
        it: "Portata dell'aria di mandata",
    },
    plant_runtime: {
        de: "Gesamtlaufzeit",
        it: "Tempo di funzionamento totale",
    },
    supply_air_flow_volume: {
        de: "Einblasluftmenge Volumen",
        it: "Volume dell'aria di mandata",
    },
    power_consumption: {
        de: "Leistung",
        it: "Potenza",
    },
    energy_consumption: {
        de: "Energieverbrauch",
        it: "Consumo di energia",
    },
    statisticType: {
        de: "Statistik auswählen",
        it: "Seleziona la statistica",
    },
    min5: {de: "5 Min.", it: "5 min"},
    min15: {de: "15 Min.", it: "15 min"},
    min30: {de: "30 Min.", it: "30 min"},
    hour1: {de: "1 Std.", it: "1 h"},
    hour3: {de: "3 Std.", it: "3 h"},
    hour6: {de: "6 Std.", it: "6 h"},
    hour12: {de: "12 Std.", it: "12 h"},
    hour24: {de: "24 Std.", it: "24 h"},
    hour72: {de: "72 Std.", it: "72 h"},
    day1: {de: "1 T", it: "1 g"},
    day3: {de: "3 T", it: "3 g"},
    day7: {de: "7 T", it: "7 g"},
    month1: {de: "1 M", it: "1 m"},
    year1: {de: "1 J", it: "1 a"},
    "1day": {
        de: "1 Tag",
        it: "1 giorno",
    },
    "1week": {
        de: "1 Woche",
        it: "1 settimana",
    },
    "1month": {
        de: "1 Monat",
        it: "1 mese",
    },
    "1year": {
        de: "1 Jahr",
        it: "1 anno",
    },
    total: {
        de: "Gesamt",
        it: "Totale",
    },
    sum: {de: "Summe", it: "Somma"},
    min: {de: "Minimum", it: "Minimo"},
    max: {de: "Maximum", it: "Massimo"},
    mean: {de: "Durchschnitt", it: "Media"},
    median: {de: "Median", it: "Mediana"},
    last: {de: "Letzter Wert", it: "Ultimo valore"},
    fromTotal: {
        de: "Seit Beginn der Aufzeichnungen",
        it: "Dall'inizio delle registrazioni",
    },
    today: {
        de: "Heute",
        it: "Oggi",
    },
    roofTemperatureHumidity: {
        de: "Dach-Temperatur / -Feuchte",
        it: "Temperatura / umidità al tetto",
    },
    roofTemperatureHumidityDesc: {
        de: "Temperatur und Feuchte Dachsensor (°C / % r.F.)",
        it: "Temperatura e umidità sensore tetto (°C / % U.R.)",
    },
    supplyAirFlowTemperatureHumidity: {
        de: "Einblas-Temperatur / -Feuchte",
        it: "Temperatura / umidità dell'aria di mandata",
    },
    supplyAirFlowTemperatureHumidityDesc: {
        de: "Temperatur und Feuchte Einblasluft (°C / % r.F.)",
        it: "Temperatura e umidità aria immessa (°C / % U.R.)",
    },
    runningTimeVolume: {
        de: "Gesamtlaufzeit",
        it: "Tempo di funzionamento totale",
    },
    runningTimeVolumeDesc: {
        de: "Summe Betriebsstunden Anlage (h)",
        it: "Ore di funzionamento cumulate impianto (h)",
    },
    maxPower: {
        de: "Höchstleistung",
        it: "Potenza massima",
    },
    maxPowerDesc: {
        de: "Höchste Leistung der Anlage (kW)",
        it: "La potenza massima con cui ha lavorato l'impianto (kW)",
    },
    energyConsumption: {
        de: "Energieverbrauch",
        it: "Consumo di energia",
    },
    energyConsumptionDesc: {
        de: "Verbrauchte Energie im Zeitraum (kWh)",
        it: "Energia consumata nel periodo (kWh)",
    },
    runningTimeStatus: {
        de: "Betriebszustand",
        it: "Stato di funzionamento",
    },
    runningTimeStatusDesc: {
        de: "Wann die Anlage ein- und ausgeschaltet war",
        it: "Quando l'impianto è stato acceso e spento",
    },
    supplyAirFlowDesc: {
        de: "Eingeblasene Luft pro Stunde (m³/h)",
        it: "Volume d'aria immesso all'ora (m³/h)",
    },
    onOff: {
        de: "Ein / Aus",
        it: "Acceso / spento",
    },
    timeWindow: {
        de: "Zeitraum",
        it: "Periodo",
    },
    chooseTimeWindow: {
        de: "Zeitraum wählen",
        it: "Seleziona il periodo",
    },
    frequencyConvertet: {
        de: "Energieverbrauch",
        it: "Consumo energetico",
    },
    actualConsumption: {
        de: "Aktueller Verbrauch",
        it: "Consumo attuale",
    },
    actualConsumptionSince: {
        de: "Verbrauch ab Start",
        it: "Consumo dall'avvio",
    },
    actualConsumptionSinceDesc: {
        de: "Summe vom Verbrauch seit Beginn der aktuellen Betriebsart. Bei einem Wechsel der Betriebsart startet die Zählung von vorne.",
        it: "Somma del consumo dall'inizio della modalità di funzionamento attuale. Al cambio di modalità il conteggio riparte da zero.",
    },
    actualConsumptionSinceDescPrioSwitch: {
        de: "Nur verfügbar, wenn der Start über die App erfolgt, bei Priorität Schalter nicht.",
        it: "Disponibile solo se l'avvio avviene tramite l'app, non con l'interruttore di priorità.",
    },
    alarm: {
        de: "Alarm",
        it: "Alarm",
    },
    alarmActive: {
        de: "Alarm aktiv",
        it: "Alarm attivo",
    },
    activeAlarms: {
        de: "Aktive Alarme",
        it: "Allarmi attivi",
    },
    roof_temperature_sensor: {
        de: "Dach-Temperatursensor",
        it: "Sensore temperatura tetto",
    },
    supply_air_temperature_sensor: {
        de: "Einblas-Temperatursensor",
        it: "Sensore temperatura aria di mandata",
    },
    roof_humidity_sensor: {
        de: "Dach-Feuchtigkeitssensor",
        it: "Sensore umidità tetto",
    },
    supply_fan_airflow_sensor: {
        de: "Einblas-Luftmengensensor",
        it: "Sensore portata aria di mandata",
    },
    supply_air_duct_pressure_sensor: {
        de: "Einblas-Drucksensor",
        it: "Sensore pressione aria di mandata",
    },
    fodder_status_sensor: {
        de: "Futterstatussensor",
        it: "Sensore stato del foraggio",
    },
    fan_airflow_speed_sensor: {
        de: "Einblas-Geschwindigkeitssensor",
        it: "Sensore velocità aria di mandata",
    },
    supply_filter_1_unit: {
        de: "Filter 1",
        it: "Filtro 1",
    },
    supply_filter_2_unit: {
        de: "Filter 2",
        it: "Filtro 2",
    },
    supply_filter_3_unit: {
        de: "Filter 3",
        it: "Filtro 3",
    },
    supply_filter_4_unit: {
        de: "Filter 4",
        it: "Filtro 4",
    },
    supply_fan_unit: {
        de: "Lüftereinheit",
        it: "Unità ventilatore",
    },
    freezeAlarm: {
        de: "Frostalarm Heizbatterie",
        it: "Allarme antigelo batteria di riscaldamento",
    },
    siemens: {
        de: "Siemens-Regler",
        it: "Regolatore Siemens",
    },
    danfoss: {
        de: "Frequenzumrichter",
        it: "Convertitore di frequenza",
    },
    highestAlarm: {
        de: "Höchste Stufe:",
        it: "Livello più alto:",
    },
    dangerAlarm: {
        de: "Gefahr",
        it: "Pericolo",
    },
    unit_stoppedAlarm: {
        de: "Gefahr",
        it: "Pericolo",
    },
    highAlarm: {
        de: "Hoch",
        it: "Alto",
    },
    hardware_errorAlarm: {
        de: "Hoch",
        it: "Alto",
    },
    lowAlarm: {
        de: "Niedrig",
        it: "Basso",
    },
    warningAlarm: {
        de: "Warnung",
        it: "Avviso",
    },
    quitAlarms: {
        de: "Alarme quittieren",
        it: "Conferma allarmi",
    },
    unitStopped: {
        de: "Anlage gestoppt",
        it: "Impianto arrestato",
    },
    andXMore: {
        de: "... und [more] weitere",
        it: "... e altri [more]",
    },
    successfullyQuitted: {
        de: "Erfolg",
        it: "Successo",
    },
    successfullyQuittedCond: {
        de: "Alarme wurden erfolgreich quittiert",
        it: "Gli allarmi sono stati confermati con successo",
    },
    quittingFailed: {
        de: "Fehlgeschlagen",
        it: "Fallito",
    },
    quittingFailedCond: {
        de: "Alarme konnten nicht quittiert werden!",
        it: "Non è stato possibile confermare gli allarmi!",
    }, trottlDruckAufnGraph: {
        de: "Tippe auf den Graph um mehr Details zu sehen",
        it: "Tocca il grafico per vedere più dettagli",
    },
    connectUnit: {
        de: "FU verbinden",
        it: "Collega convertitore di frequenza",
    },
    alarmType: {
        de: "Alarmstufe",
        it: "Livello di allarme",
    },
    alarmHistory: {
        de: "Alarmverlauf",
        it: "Storico allarmi",
    },
    noAlarms: {
        de: "Keine Alarme verfügbar!",
        it: "Nessun allarme disponibile!",
    },
    noAlarmsInThisTime: {
        de: "In diesem Zeitraum war kein Alarm aktiv",
        it: "In questo periodo non era attivo alcun allarme",
    },
    active: {
        de: "Aktiv",
        it: "Attivo",
    },
    from: {
        de: "von",
        it: "da",
    },
    until: {
        de: "bis",
        it: "a",
    },
    stopUnknown: {
        de: "Ende unbekannt",
        it: "Fine sconosciuta",
    },
    startUnknown: {
        de: "Beginn unbekannt",
        it: "Inizio sconosciuto",
    },
    energyConsumtionExpl: {
        de: "Zeigt die Energie in kWh, die die Anlage im jeweiligen Abschnitt aus dem Netz bezogen hat. In der Wochen- und Monatsansicht ist jeder Balken ein Kalendertag, in der Jahresansicht ein Kalendermonat, in der Gesamtansicht eine Kalenderwoche (Montag bis Sonntag). Grundlage ist der Energiezähler des Frequenzumrichters; die Verluste zwischen Netz und Motor werden rechnerisch aufgeschlagen. Fehlen zeitweise Messdaten, geht kein Verbrauch verloren: Er wird dem nächsten Abschnitt mit Messdaten zugerechnet.",
        it: "Mostra l'energia in kWh prelevata dalla rete dall'impianto nel rispettivo intervallo. Nella vista settimanale e mensile ogni barra corrisponde a un giorno di calendario, nella vista annuale a un mese di calendario, nella vista complessiva a una settimana di calendario (da lunedì a domenica). La base è il contatore di energia del convertitore di frequenza; le perdite tra rete e motore vengono aggiunte tramite calcolo. Se mancano temporaneamente dati di misurazione, nessun consumo va perso: viene attribuito al successivo intervallo con dati di misurazione.",
    },
    runningTimeVolumeExpl: {
        de: "Zeigt, wie viele Stunden die Anlage im jeweiligen Abschnitt eingeschaltet war. Die Abschnitte sind dieselben wie beim Energieverbrauch. Die Laufzeit wird aus der minütlichen Statusabfrage berechnet: Ein Zustand gilt bis zur nächsten Abfrage, die Genauigkeit liegt also bei etwa einer Minute. Fehlen länger als 15 Minuten Daten (z. B. bei einem Verbindungsausfall), wird diese Zeit nicht mitgezählt; die tatsächliche Laufzeit kann dann etwas höher sein.",
        it: "Mostra per quante ore l'impianto è stato acceso nel rispettivo intervallo. Gli intervalli sono gli stessi del consumo energetico. Il tempo di funzionamento viene calcolato dalla rilevazione dello stato al minuto: uno stato vale fino alla rilevazione successiva, quindi la precisione è di circa un minuto. Se mancano dati per più di 15 minuti (ad es. in caso di interruzione della connessione), questo periodo non viene conteggiato; il tempo di funzionamento effettivo può quindi essere leggermente superiore.",
    },
    maxPowerExpl: {
        de: "Zeigt die höchste aus dem Netz bezogene Leistung in kW: in der Tagesansicht pro 5-Minuten-Abschnitt, in der Wochenansicht pro 30-Minuten-Abschnitt. Grundlage ist die Leistungsmessung des Frequenzumrichters; die Verluste zwischen Netz und Motor werden rechnerisch aufgeschlagen. Die Leistung wird einmal pro Minute abgefragt; sehr kurze Spitzen zwischen zwei Abfragen sind daher nicht sichtbar.",
        it: "Mostra la potenza massima prelevata dalla rete in kW: nella vista giornaliera per intervalli di 5 minuti, nella vista settimanale per intervalli di 30 minuti. La base è la misurazione della potenza del convertitore di frequenza; le perdite tra rete e motore vengono aggiunte tramite calcolo. La potenza viene rilevata una volta al minuto; picchi molto brevi tra due rilevazioni non sono quindi visibili.",
    },
    runningTimeStatusExpl: {
        de: "Zeigt, ob die Anlage lief: in der Tagesansicht pro 5-Minuten-Abschnitt, in der Wochenansicht pro 30-Minuten-Abschnitt. Ein Abschnitt gilt nur dann als „läuft“, wenn die Anlage während des gesamten Abschnitts eingeschaltet war. Ein kurzes Ausschalten oder ein Lauf, der kürzer ist als der Abschnitt, wird als „läuft nicht“ dargestellt. Für die genaue Betriebsdauer nutze die Auswertung „Laufzeit“.",
        it: "Mostra se l'impianto era in funzione: nella vista giornaliera per intervalli di 5 minuti, nella vista settimanale per intervalli di 30 minuti. Un intervallo è considerato «in funzione» solo se l'impianto è rimasto acceso per tutta la sua durata. Uno spegnimento breve o un funzionamento più breve dell'intervallo viene mostrato come «non in funzione». Per la durata esatta di funzionamento usa la valutazione «Tempo di funzionamento».",
    },
    roofTempSupplyAirExpl: {
        de: "In der Tagesansicht wird für jeden 5-Minuten-Abschnitt der zuletzt gemessene Wert angezeigt, in der Wochenansicht für jeden 30-Minuten-Abschnitt. Es handelt sich um Momentaufnahmen, nicht um Durchschnittswerte; Schwankungen innerhalb eines Abschnitts sind daher nicht sichtbar.",
        it: "Nella vista giornaliera viene mostrato, per ogni intervallo di 5 minuti, l'ultimo valore misurato; nella vista settimanale, per ogni intervallo di 30 minuti. Si tratta di istantanee, non di valori medi; le oscillazioni all'interno di un intervallo non sono quindi visibili.",
    },
    pushNotifications: {
        de: "Push-Benachrichtigungen",
        it: "Notifiche push",
    },
    pushNotificationsExpl: {
        de: "Bei Alarmen eine Benachrichtigung auf dieses Gerät senden.",
        it: "Invia una notifica a questo dispositivo in caso di allarme.",
    },
    pushNeedsInstall: {
        de: "Füge die App zum Home-Bildschirm hinzu, um Benachrichtigungen zu erhalten.",
        it: "Aggiungi l'app alla schermata Home per ricevere notifiche.",
    },
    pushDenied: {
        de: "Benachrichtigungen sind in den Browser-Einstellungen blockiert.",
        it: "Le notifiche sono bloccate nelle impostazioni del browser.",
    },
    pushError: {
        de: "Benachrichtigungen konnten nicht aktiviert werden.",
        it: "Impossibile attivare le notifiche.",
    },
    activate: {
        de: "Aktivieren",
        it: "Attivare",
    },
    sureWantLogout: {
        de: "Bist du sicher, dass du dich abmelden willst? Du benötigst dein Passwort, um deine Anlage wieder zu sehen!",
        it: "Sei sicuro di volerti disconnettere? Ti servirà la password per rivedere il tuo impianto!",
    },
    dotHour: {
        de: "[hour] Uhr",
        it: "ore [hour]",
    },
    infoBoxCustomDate: {
        de: "Mindestens 1 Stunde, Maximal 7 Tage",
        it: "Al minimo 1 ora, massimo 7 giorni",
    },
    infoBoxCustomDateDateOnly: {
        de: "Mindesten 2 Tage",
        it: "Al minimo 2 giorni",
    },
    emptyString: {
        de: "",
        it: "",
    }
};

export declare type TranslatorKeys = keyof typeof generalKeywords;
const keywords: Keywords = {...generalKeywords};

export function trans(
    key: TranslatorKeys,
    lang: LanguageLocale,
    params?: { [T in string]: string }
): string {
    const keyword: Keyword = keywords[key];

    if (typeof keyword === "undefined") {
        return key;
    }
    if (params === undefined) {
        return keyword[lang];
    }
    let text = keyword[lang];
    const paramKeys = Object.keys(params);
    paramKeys.forEach((param) => {
        text = text.replace(param, params[param]);
    });
    return text;
}
